module.exports = __webpack_public_path__ + "static/media/dientes_encimados.4396f394.svg";